"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookFilledCircleIcon = void 0;
var react_1 = __importDefault(require("react"));
var cn_1 = require("../../../utils/cn");
var cls = (0, cn_1.classNames)('facebook-filled-circle-icon');
var FacebookFilledCircleIcon = function (_a) {
  var className = _a.className;
  return react_1.default.createElement("svg", {
    className: cls.name(className),
    width: "16",
    height: "16",
    viewBox: "0 0 40 40"
  }, react_1.default.createElement("path", {
    d: "M20 0C16.0444 0 12.1776 1.17298 8.88861 3.37061C5.59963 5.56824 3.03617 8.69182 1.52242 12.3463C0.00866562 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7815 3.06083 31.3451 5.85788 34.1422C8.65493 36.9392 12.2186 38.8441 16.0982 39.6158C19.9778 40.3875 23.9992 39.9914 27.6537 38.4776C31.3082 36.9639 34.4318 34.4004 36.6294 31.1115C38.827 27.8225 40 23.9557 40 20C40 14.6957 37.8929 9.60861 34.1421 5.85787C30.3914 2.10714 25.3043 0 20 0V0ZM29.7375 28.4625C29.7375 29.05 29.4375 29.7125 28.8625 29.7125H23.9375V22.3375H26.4375L26.825 19.175H23.9375V17.25C23.9375 16.4125 24.1625 16 25.375 16H27.1V13.25C26.575 13.25 25.75 13.1375 24.6875 13.1375C24.1683 13.0951 23.6461 13.1651 23.1564 13.3427C22.6667 13.5202 22.221 13.8013 21.8497 14.1667C21.4784 14.532 21.1902 14.9731 21.0048 15.4599C20.8193 15.9467 20.741 16.4677 20.775 16.9875V19.1625H18.1375V22.325H20.775V29.7H11.65C11.0625 29.7 10.7625 29.075 10.7625 28.45V11.25C10.7625 10.6625 11.0625 10.1875 11.65 10.1875H28.8625C29.4375 10.1875 29.7375 10.6625 29.7375 11.25V28.4625Z",
    fill: "white"
  }));
};
exports.FacebookFilledCircleIcon = FacebookFilledCircleIcon;